import { useLazyQuery } from '@apollo/client';
import { IQueryResult, IVariables } from './interfaces';
import { qualityReturnPictureListQuery } from './gql';

export const useQualityReturnPictureListGql = () => {
  const [runQualityReturnPictureListGql, { loading, data, error }] = useLazyQuery<IQueryResult, IVariables>(
    qualityReturnPictureListQuery,
    {
      context: {
        headers: {
          userFunctionKey: 'a684eceee76fc522773286a895bc8436'
        }
      }
    }
  );

  return {
    runQualityReturnPictureListGql,
    loadingQualityReturnPictureList: loading,
    dataQualityReturnPictureList: data?.getReturnReceiptPicturesURL || [],
    errorQualityReturnPictureList: error
  };
};
